import { Text } from "@/components/atoms/Text";

export type CalendarAvailabilityKeyProps = {
  bookedCopy?: string;
  availableCopy?: string;
};

export const CalendarAvailabilityKey = ({
  bookedCopy = "Booked",
  availableCopy = "Available",
}: CalendarAvailabilityKeyProps) => {
  return (
    <div className="tw-flex tw-items-center tw-gap-16">
      <Text
        typeface="caption-2"
        prefix={
          <span className="tw-w-12 tw-h-2 tw-bg-purple-600 tw-rounded-8" />
        }
      >
        {bookedCopy}
      </Text>

      <Text
        typeface="caption-2"
        prefix={<span className="tw-w-12 tw-h-2 tw-bg-gray-300 tw-rounded-8" />}
      >
        {availableCopy}
      </Text>
    </div>
  );
};
